import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchWrapper } from './../_helpers';


// create slice

const name = 'vendors';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const vendorActions = { ...slice.actions, ...extraActions };
export const vendorReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        vendor:{},
        vendorList: [],
         isLoading:false,
        error: null,
        vendorResponse: [],
        deletevendorResponse:[]
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/Vendor`;
    return {
        getVendorAll: getVendorAll(),
       getVendorById:getVendorById(),
        saveVendor: saveVendor(),
        deleteVendor:deleteVendor(),
    };

    function getVendorAll() {
        return createAsyncThunk(
            `${name}/getVendorAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetVendorDetails`)
        );
    }
     function getVendorById() {
        return createAsyncThunk(
            `${name}/getVendorById`,
             async (VendorDetail) => await fetchWrapper.get(`${baseUrl}/GetVendorDetails?VendorID=`+VendorDetail.VendorID)
        );
    }

    function saveVendor() {
        return createAsyncThunk(
            `${name}/saveVendor`,
            async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateVendor`, addFormData )
        );
    }

    function deleteVendor()
    {
        return createAsyncThunk(
            `${name}/deleteVendor`,
             async (VendorDetail) => await fetchWrapper.post(`${baseUrl}/DeleteVendor?VendorID=${VendorDetail.VendorID}&DeletedBy=${VendorDetail.DeletedBy}`)
          
        );
    }
}

function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getVendorAll.pending, (state) => { //getVendorAll
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getVendorAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.vendorList = action.payload || [];
            state.vendorResponse = [];
            state.deletevendorResponse = [];
        })
        .addCase(extraActions.getVendorAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getVendorById.pending, (state) => { //getVendorById
            state.vendor = { loading: true };
        })
        .addCase(extraActions.getVendorById.fulfilled, (state, action) => {
            state.vendor = action.payload ? action.payload[0] : null;
            state.vendorResponse = [];
            state.deletevendorResponse = [];
        })
        .addCase(extraActions.getVendorById.rejected, (state, action) => {
            state.vendor = { error: action.error };
        })
        .addCase(extraActions.saveVendor.pending, (state) => { //saveVendor
            state.vendorResponse = { loading: true };
        })
        .addCase(extraActions.saveVendor.fulfilled, (state, action) => {
            state.vendorResponse = action.payload;
            state.deletevendorResponse = [];
        })
        .addCase(extraActions.saveVendor.rejected, (state, action) => {
            state.vendorResponse = { error: action.error };
        })
        .addCase(extraActions.deleteVendor.pending, (state) => { //deleteVendor
            state.deletevendorResponse = { loading: true };
        })
        .addCase(extraActions.deleteVendor.fulfilled, (state, action) => {
            state.deletevendorResponse = action.payload;
            state.vendorResponse = [];
        })
        .addCase(extraActions.deleteVendor.rejected, (state, action) => {
            state.deletevendorResponse = { error: action.error };
        });
}

